import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <main className="min-h-screen bg-white" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
      {/* Simple Header */}
      <header className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-gray-100">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div
              className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent"
              style={{ fontFamily: '"Montserrat", sans-serif' }}
            >
              Privacy
            </div>
            <span className="text-sm text-gray-500">プライバシーポリシー</span>
          </div>

          <div className="flex items-center gap-4">
            <Link
              to="/"
              className="text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors"
            >
              ホームへ戻る
            </Link>
          </div>
        </div>
      </header>

      <section className="py-16">
        <div className="max-w-5xl mx-auto px-6">
          <div className="mb-10">
            <span className="text-blue-600 font-bold text-sm tracking-wider uppercase mb-3 block">
              Privacy Policy
            </span>
            <h1 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
              プライバシーポリシー
            </h1>
            <p className="text-gray-600 leading-relaxed">
              当社は、お客様の個人情報を適切に取り扱い、保護することを重要な責務と考えています。
              本ポリシーは、当社が取得する個人情報の取扱いについて定めるものです。
            </p>
            
          </div>

          {/* Card */}
          <div className="bg-white rounded-3xl p-8 md:p-10 shadow-2xl border border-gray-100">
            <div className="space-y-10 text-gray-700 leading-relaxed">
              <section>
                <h2 className="text-2xl font-black text-gray-900 mb-3">1. 事業者情報</h2>
                <div className="bg-gray-50 border border-gray-100 rounded-2xl p-6 text-sm">
                  <div className="grid md:grid-cols-1 gap-4">
                    <div>
                      <div className="text-gray-500">事業者名</div>
                      <div className="font-bold text-gray-900">株式会社TCY</div>
                    </div>
                    <div>
                      <div className="text-gray-500">所在地</div>
                      <div className="font-bold text-gray-900">静岡県伊東市富戸８７７番地の４</div>
                    </div>
                    
                    <div>
                      <div className="text-gray-500">連絡先</div>
                      <div className="font-bold text-gray-900">tcy.sales@tcy-sales.com</div>
                    </div>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-black text-gray-900 mb-3">2. 取得する情報</h2>
                <p className="text-gray-600 mb-4">
                  当社は、お問い合わせ・資料請求・サービス提供等のため、以下の情報を取得することがあります。
                </p>
                <ul className="space-y-2">
                  {[
                    "氏名、会社名（任意）、メールアドレス、電話番号",
                    "お問い合わせ内容（ご希望サービス、メッセージ等）",
                    "アクセスログ（IPアドレス、UserAgent、閲覧日時、参照元等）",
                    "Cookie等により収集される情報（利用する場合）",
                  ].map((t) => (
                    <li key={t} className="flex items-start gap-3">
                      <span className="mt-2 w-2 h-2 bg-blue-600 rounded-full flex-shrink-0"></span>
                      <span>{t}</span>
                    </li>
                  ))}
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-black text-gray-900 mb-3">3. 利用目的</h2>
                <ul className="space-y-2">
                  {[
                    "お問い合わせへの対応、連絡、本人確認",
                    "サービスの提供、運用、改善、品質向上",
                    "必要に応じた重要なお知らせ等の連絡",
                    "不正利用の防止・セキュリティの確保",
                    "統計情報としての分析（個人を特定しない形式）",
                  ].map((t) => (
                    <li key={t} className="flex items-start gap-3">
                      <span className="mt-2 w-2 h-2 bg-cyan-600 rounded-full flex-shrink-0"></span>
                      <span>{t}</span>
                    </li>
                  ))}
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-black text-gray-900 mb-3">4. 第三者提供</h2>
                <p className="text-gray-600">
                  当社は、法令に基づく場合を除き、本人の同意なく個人情報を第三者に提供しません。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-black text-gray-900 mb-3">5. 委託</h2>
                <p className="text-gray-600">
                  当社は、業務遂行に必要な範囲で、個人情報の取扱いを外部事業者に委託する場合があります。
                  この場合、適切な委託先の選定と監督を行います。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-black text-gray-900 mb-3">6. 安全管理措置</h2>
                <p className="text-gray-600">
                  当社は、個人情報の漏えい、滅失または毀損の防止その他個人情報の安全管理のために、
                  必要かつ適切な措置を講じます。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-black text-gray-900 mb-3">7. 開示・訂正・削除等</h2>
                <p className="text-gray-600">
                  本人から個人情報の開示、訂正、利用停止、削除等の請求があった場合、
                  法令に従い適切に対応します。下記「お問い合わせ窓口」までご連絡ください。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-black text-gray-900 mb-3">8. Cookie等について</h2>
                <p className="text-gray-600">
                  当社サイトでは、利便性向上やアクセス解析のためにCookie等を利用する場合があります。
                  ブラウザの設定によりCookieを無効化できますが、一部機能が利用できない場合があります。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-black text-gray-900 mb-3">9. お問い合わせ窓口</h2>
                <div className="bg-gradient-to-br from-blue-50 to-cyan-50 border border-blue-100 rounded-2xl p-6">
                  <p className="text-gray-700 mb-2">
                    本ポリシーに関するお問い合わせは、下記までご連絡ください。
                  </p>
                  <div className="text-sm text-gray-700 space-y-1">
                    <div>事業者名：株式会社TCY</div>
                    <div>メール：tcy.sales@tcy-sales.com</div>
                    <div>受付時間：平日 9:00〜18:00（例）</div>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-black text-gray-900 mb-3">10. 改定</h2>
                <p className="text-gray-600">
                  当社は、必要に応じて本ポリシーを改定することがあります。改定後の内容は当社サイトに掲載します。
                </p>
              </section>
            </div>
          </div>

          {/* Footer back */}
          <div className="mt-10 flex justify-center">
            <Link
              to="/#contact"
              className="px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-500 text-white text-lg font-bold rounded-full hover:shadow-2xl transition-all duration-300 whitespace-nowrap"
            >
              お問い合わせへ戻る
            </Link>
          </div>
        </div>
      </section>

      <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center">
            <div className="text-4xl font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent mb-4" style={{ fontFamily: '"Montserrat", sans-serif' }}>TCY</div>
            <p className="text-gray-400 mb-8">売上を加速する営業のプロ</p>
            <div className="flex justify-center gap-8 mb-8 flex-wrap">
              <a href="/#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">サービス</a>
              <a href="/#strengths" className="text-gray-400 hover:text-white transition-colors cursor-pointer">強み</a>
              <a href="/#flow" className="text-gray-400 hover:text-white transition-colors cursor-pointer">導入の流れ</a>
              <a href="/#about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">会社情報</a>
              <a href="/#contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">お問い合わせ</a>
              <a href="/privacy" className="text-gray-400 hover:text-white transition-colors cursor-pointer">プライバシーポリシー</a>
            </div>
            <div className="border-t border-gray-700 pt-8">
              <p className="text-gray-400 text-sm">
                &copy; 2024 株式会社TCY. All rights reserved. 
              </p>
            </div>
          </div>
        </div>
      </footer>
    </main>
  );
}
